



import Check from "rutas/check";

import MSDK from "views/maps/m-sdk";
import ReportesTratamientoDepto from "views/diagnostico/reportes/reportes_tratamiento_depto";
import ReportesDiagnosticoDepto from "views/diagnostico/reportes/reportes_diagnostico_depto";

import Icons from "views/Icons";
import ReportesTratamientoDepartamental from "views/diagnostico/reportes/reportes_tratamiento_departamental";
import ReportesDiagnosticoDepartamental from "views/diagnostico/reportes/reportes_diagnostico_departamental";
import Ficha from "views/diagnostico/ficha";
var RoutesReportesTratamientoDepto = [

  {
    path: "/main",
    name: "TRATAMIENTO",
    icon: "tim-icons  icon-notes",
    component: <ReportesTratamientoDepartamental />,
    layout: "/reportes-tratamiento-depto",
  },


  {
    path: "/dx",
    name: "Diagnostico",
    icon: "tim-icons  icon-notes",
    component: <ReportesDiagnosticoDepartamental />,
    layout: "/reportes-tratamiento-depto",
  },

  {
    path: "/fichas",
    name: "FICHA",
    icon: " tim-icons  icon-badge",
    component: <Ficha />,
    layout: "/reportes-tratamiento-depto",
  },
  {
    path: "/georef",
    name: "Georeferenciaciones UBE",
    icon: "tim-icons icon-pin",
    component: <Check component={MSDK} />,
    layout: "/reportes-tratamiento-depto",
  },

  // {
  //   path: "/icons",
  //   name: "icons",
  //   icon: "tim-icons icon-pin",
  //   component: <Icons />,
  //   layout: "/tratamiento",
  // },



];
export default RoutesReportesTratamientoDepto;
